import Address from 'types/models/address';
import User from 'types/models/user';

export type EnterpriseId = number;
export type EnterpriseSubdomain = string | null;
export type EnterpriseName = string;

export enum Industry {
  AGRICULTURE = 'agriculture',
  MINING = 'mining'
}

/** @see {@link https://farmbot-au.atlassian.net/wiki/spaces/DEV/pages/1779695621/Back+Office+Enterprise+Statuses Back-office Enterprise Statuses}*/
export enum EnterpriseStatus {
  ACTIVE = 'active',
  DEMO = 'demo',
  DISABLED = 'disabled',
  DUPLICATE = 'duplicate',
  PAST_DUE = 'past_due',
  TEST = 'test',
  TRIAL = 'trial',
  TRIAL_EXPIRED = 'trial_expired'
}

export interface EnterpriseIntegration {
  id: number;
  agriWebbOrganizationId: string;
  agriWebbStatus: 'enabled' | 'error' | 'disconnected';
}

export default interface Enterprise {
  id: EnterpriseId;
  sid: string;
  name: EnterpriseName;
  industry: Industry;
  status: EnterpriseStatus;
  /**
   * When the request cannot find the owner (`owner_id: null`):
   * - by default, the API will skip the `owner` field (i.e. `owner: undefined`).
   * - if the request explicitly sets `join=owner`, the API will return `owner: null`.
   */
  owner: User | undefined | null;
  ownerId: number | null;
  billingAddress?: Address;
  billingAddressId?: number;
  subdomain: EnterpriseSubdomain;
  note: string | null;
  createdAt: number;
  updatedAt: number;

  enterpriseIntegration?: EnterpriseIntegration | null;

  /**
   * Account for fields that are returned from the api but not used.
   */
  [key: string]: unknown;
}
